const apiBasePath = 'http://aztektec.com.mx:9080/kiosko-factura-bdi';
// const apiBasePath = 'http://siereportes.dyndns.org:9080/kiosko-factura-bdi';// DEV
const apiBasePathSigie = 'http://aztektec.com.mx:9080/back-sigie';

// Constants for SessionStorage
const sessionStorageKey_session = 'session';
const sessionStorageKey_menuRoutes = 'contextMenuRoutes';

const NOTIFICATION_BELL_COLOR = '#d3d3d3';


const MENU_CUSTOMER = [
  {
    description: 'Facturación',
    item: [
      { path: 'invoice-tickets', description: 'Boletaje' },
      { path: 'invoice-storage', description: 'Pensiones' }
    ]
  },
  { path: 'invoice-list', description: 'Mis Facturas' }
];

const MENU_ADMIN = [ // nuevo
  {
    description: 'Facturación',
    item: [{ path: 'invoice-tickets', description: 'Boletaje/Pensiones' }]
  },
  { path: 'invoice-monitor', description: 'Monitor Facturas' },
  { path: 'invoice-management', description: 'Gestión' },
  {
    description: 'Mantenimiento',
    item: [{ path: 'client-list', description: 'Clientes' }]
  }
];

const optionRoles = {
  isCorporate: 0,
  isOperator: 0,
  isSupervisor: 0,
  isSystem: 0
};

const CAR_STORAGE_FETCH_INFO = {
  method: 'post',
  url: 'income',
  sendIncomeValues: {
    active: 1,
    comment: '',
    incomeStatusOid: 1,
    incomeTypeOid: 2
  }
};

const DICCIONARIO_COLOR_STATUS_INCOMES = {
  0: {
    'Pendiente TF': {
      null: 'orange',
      error: 'red'
    }
  },
  1: {
    1: {
      null: 'green',
      error: 'purple'
    }
  },
  2: {
    Cancelada: {
      null: 'cyan',
      error: 'red'
    }
  }
};

const BACK_OFFICE_STATES = [2, 3, 4, 5];

const DEFAULT_TABLE_EMPTY_MSG = (
  <div className="custom-table-empty-message">
    <p>
      <b>No se encontraron datos disponibles.</b>
    </p>
    <p>Por favor, ingrese la información necesaria para continuar.</p>
  </div>
);

const CAR_STORAGE_TABLE_EMPTY_MSG = (
  <div className="custom-table-empty-message">
    <p>
      <b>No se encontraron registros en este período</b>
    </p>
    <p>Por favor, seleccione otro período para continuar.</p>
  </div>
);

const ACTIVE = 1;
const STORAGE_INCOME_TYPE_OID = 2;
const CALENDAR_DAYS_AVAILABLE = 15;


const REFRESH_INTERVAL = 10000;
const REFRESH_INTERVAL_OPTIONS = [
  { value: 5000, label: '5s' },
  { value: 10000, label: '10s' },
  { value: 15000, label: '15s' },
  { value: 30000, label: '30s' },
  { value: 60000, label: '1m' },
  { value: 180000, label: '3m' },
  { value: null, label: 'off' }
];

export {
  apiBasePath,
  apiBasePathSigie,
  sessionStorageKey_session,
  sessionStorageKey_menuRoutes,
  optionRoles,
  ACTIVE,
  BACK_OFFICE_STATES,
  CALENDAR_DAYS_AVAILABLE,
  CAR_STORAGE_FETCH_INFO,
  CAR_STORAGE_TABLE_EMPTY_MSG,
  DEFAULT_TABLE_EMPTY_MSG,
  DICCIONARIO_COLOR_STATUS_INCOMES,
  STORAGE_INCOME_TYPE_OID,
  MENU_CUSTOMER,
  MENU_ADMIN,
  REFRESH_INTERVAL,
  REFRESH_INTERVAL_OPTIONS,
  NOTIFICATION_BELL_COLOR
};
